import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-6 col-12 ps-lg-0 chartRes mt-5" }
const _hoisted_2 = { class: "col-lg-6 col-12 pe-lg-0 chartRes mt-5" }

import ChartLineActiveUser from './ChartActiveUserChildren'
import { translate } from '@/languages/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  date: Object,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ChartLineActiveUser), {
        date: __props.date,
        step: 40,
        title: _unref(translate)('CB10titletUser'),
        weekly_flag: false
      }, null, 8, ["date", "title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ChartLineActiveUser), {
        date: __props.date,
        step: 20,
        title: _unref(translate)('Cb10titleUserActives'),
        weekly_flag: true
      }, null, 8, ["date", "title"])
    ])
  ], 64))
}
}

})